import React, {Component} from 'react';
import './Form.css';
import FormErrorMessages from './FormErrorMessages';
import LoadingScreen from './LoadingScreen';
// import AutoCompleteCityField from './AutoCompleteCityField';
// import AutoCompleteAddressField from './AutoCompleteAddressField';
// import AutoCompleteRegionField from './AutoCompleteRegionField';
// import { getAutoCompleteState, getAutoCompleteZipCode, getAutoCompleteCity, getAutoCompleteStreetNumber, getAutoCompleteStreetName } from '../utils/places';

// import Script from 'react-load-script';

class Form extends Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.autocomplete = null;
    this.addressRef = React.createRef();
    this.cityRef = React.createRef();
    this.zipCodeRef = React.createRef();
    
    this.state = {
      fields: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        birthDay: '',
        birthMonth: '',
        address1: '',
        address2: '',
        city:'',
        state: '',
        zipCode: '',
        tvProvider: '',
        agreeEmail: true, 
        agreeText: false,
        panelHeight: 0,
        validatedAddress: '',
        lastSubmission: Date.now()
      },
      isLoading: false,
      errors: {},
      requiredFields: {
        'firstName':'First Name Required', 
        'email':'Email Required'
      },
      userInitSubmit: false,
      submitForm: false
    }

    this.formPanel = React.createRef();
  }

  handleSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const errors = this.formValidation();

    // this.props.handleSubmit(this.state);
    this.setState({
      userInitSubmit: true,
      isLoading: true,
      errors
    });

  }

  handleFieldChange(evt) {
    const {name, type, value} = evt.target;
    let fieldVal = value;
    
    // console.log('handleFieldChange', (type==='tel' && !!!this.handlePhoneFieldChange(evt) && value), (type!=='checkbox' && value), !this.state.fields[name])
    if (type==='tel') {
      fieldVal = this.handlePhoneFieldChange(value, evt);
    }
    
    if (type==='checkbox') {
      fieldVal = !this.state.fields[name];
    }

    const fields = Object.assign(this.state.fields, {[name]:fieldVal});
    this.setState({fields});
  }
  
  handlePhoneFieldChange(str, evt) {
		//ignore backspace and delete keys
		if (evt.keyCode !== 8 && evt.keyCode !== 46) {
			const val = str.replace(/\D/g,'');
			
      return val.substring(0,3) + '-' + val.substring(3,6) + '-' + val.substring(6,10);
		}
	}

  hasErrors() {
    return Object.keys(this.state.errors).length !== 0;
  }

  setRequiredFieldsError() {
    const {requiredFields, fields} = this.state,
      errors = {},
      fieldsWithErrors = Object.keys(requiredFields).filter(name=>fields[name]==='');

    fieldsWithErrors.forEach(name=>errors[name]=requiredFields[name])

    return errors;
  }

  formValidation(errors) {
    const { fields } = this.state,
      validationErrors = {},
      requiredFieldsErrors = this.setRequiredFieldsError();

    const emptyPhoneField = !fields.phoneNumber || fields.phoneNumber === '--';

    if (!emptyPhoneField && !(/\d{3}-\d{3}-\d{4}/.test(fields.phoneNumber))) {
      validationErrors['phoneNumber'] = 'Incorrect Phone Number format ex. XXX-XXX-XXX';
    }
    
    if (fields.agreeText && emptyPhoneField) {
      validationErrors['phoneNumber'] = 'Phone Number Format Error ex. XXX-XXX-XXX.';
    }
// console.log('formValidation', Object.assign(errors, validationErrors));
    return Object.assign(requiredFieldsErrors, validationErrors);
  }

  backendValidationErrors() {
    const submitError = (this.props.submitError) || this.state.errors,
      errors = Object.assign({errors: submitError});

    this.setState({errors: submitError});
  }

  // Passed to result panel to set height of result panel
  setFormPanelHeight() {
    const panelHeight = this.formPanel.current.clientHeight,
      fields = Object.assign(this.state.fields, {panelHeight});

    this.setState({fields});
  }

  // populate with local storage data or data returned after backend validation error
  populateWithData() {
    const { data } = this.props;
    const fields = Object.assign(this.state.fields, data);

    console.log('populateWithData', data, Object.keys(data).length);
    Object.keys(data).length > 0 && this.setState({fields});
  }

  componentDidMount() {
    this.setFormPanelHeight();
    this.populateWithData();
  }

  render() {

    const classNames = {
      firstName: 'first-name',
      lastName: 'last-name',
      email: 'email',
      phoneNumber: 'phone-number'
    }

    const {
      errors,
      fields
    } = this.state;

    const {
      isHint,
      isRevealAllAnswer
    } = this.props;

    let h3Label = <h3>Need points?</h3>;
    let submitBtnLabel = 'Get Points';

    if (isHint) {
      h3Label = <h3>Need a hint?</h3>;
      submitBtnLabel = 'Get Your Hint';
    }

    if (isRevealAllAnswer) {
      h3Label = <h3>Reveal all answers?</h3>;
      submitBtnLabel = 'Reveal Answers';
    }

    if (errors) {
      Object.keys(errors).forEach((key)=>{
        classNames[key] += ' error';
      });
    }



    return (
      <div className="submission-form">
        <form action="" method="post" onSubmit={this.handleSubmit}>
          <div className="form-fields" ref={this.formPanel}>
            {h3Label}
            <h3>Sign up for our newsletter!</h3>
            <FormErrorMessages
              errors={errors}
              />
            <fieldset>
              <input className={classNames['firstName']} name="firstName" placeholder="First Name*" onChange={this.handleFieldChange} required value={fields.firstName} />
              <input type="email" className={classNames['email']} name="email" placeholder="Email*" onChange={this.handleFieldChange} required value={fields.email} />
            </fieldset>
            <fieldset>
              <select className={"birth-month" + (fields.birthMonth?' filled':'')} name="birthMonth" onChange={this.handleFieldChange} value={fields.birthMonth} >
                <option value="">Birth Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
              <select className={"birth-day" + (fields.birthDay?' filled':'')} name="birthDay" onChange={this.handleFieldChange} value={fields.birthDay} >
                <option value="">Birth Day</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
           </select>
            </fieldset>
            <fieldset>
              <div className="legal">
                <p>
                  BY CLICKING "{submitBtnLabel}" YOU ARE OPTING INTO THE NEWSLETTER.  I ACKNOWLEDGE I AM 18 YEARS OLD OR OLDER AND AGREE TO THE <a href="https://www.gameshownetwork.com/legal/privacy-policy" target="_blank">PRIVACY POLICY</a>.
                </p>
              </div>
              <button className="submit gotham-ultra">{submitBtnLabel}</button>
            </fieldset>
            {this.state.isLoading &&
              // <LoadingScreen />
              <div />
            }
          </div>
        </form>
        {/* <Script 
          url="https://maps.googleapis.com/maps/api/js?key=AIzaSyBYxzlRTHuRxuOLvDShKLQ16rsabTEmcdE&libraries=places"          
          onLoad={this.handlePlacesScriptLoad}        
        />  */}
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.populateWithData();
    }

    if (prevProps.submitError!==this.props.submitError) {
      this.setState({isLoading:false});
      this.backendValidationErrors();
    }

    //submitting data to backend
    if (this.state.submitForm === true && prevState.submitForm !== this.state.submitForm) {
      this.props.handleSubmit(this.state.fields);
      this.setState({submitForm: false});
    }

    //check errors before submitting
    if (this.state.userInitSubmit === true && prevState.userInitSubmit !== this.state.userInitSubmit) {
      if (!this.hasErrors()){
        this.setState({submitForm: true});
      } else {
        this.setState({isLoading: false});
      }
      this.setState({userInitSubmit: false});
    } 
  }
}

export default Form;